import { createContext } from 'react';

const { shop = '' } = window.Shopify || {};
export const ShopContext = createContext(shop);
